module.exports = __webpack_public_path__ + "media/CN_011.4c70cc24.mp3";